export const subscriber = {
  id: 1
}
